/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Stopwatch`)
};

const es_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronómetro Online`)
};

const de_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online-Stoppuhr`)
};

const nl_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Stopwatch`)
};

const fr_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronomètre en ligne`)
};

const it_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometro Online`)
};

const pt_br2_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronômetro Online`)
};

const pt_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronómetro Online`)
};

const ja_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインストップウォッチ`)
};

const zh_timer_stopwatch_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线秒表`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_h1", locale)
	if (locale === "en") return en_timer_stopwatch_h1(inputs)
	if (locale === "es") return es_timer_stopwatch_h1(inputs)
	if (locale === "de") return de_timer_stopwatch_h1(inputs)
	if (locale === "nl") return nl_timer_stopwatch_h1(inputs)
	if (locale === "fr") return fr_timer_stopwatch_h1(inputs)
	if (locale === "it") return it_timer_stopwatch_h1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_h1(inputs)
	if (locale === "pt") return pt_timer_stopwatch_h1(inputs)
	if (locale === "ja") return ja_timer_stopwatch_h1(inputs)
	return zh_timer_stopwatch_h1(inputs)
};